import React from 'react';
import styles from './CTASection.module.css';
import CTABackground from './CTABackground';
import CTAOverlay from './CTAOverlay';
import CTAContent from './CTAContent';
import { CTA_DATA } from '../../../../constants/landing';

/**
 * @component CTASection
 * @description 랜딩 페이지 최종 전환 유도 섹션
 *
 * 레이어 구조 (z-index):
 *   0: CTABackground  — 배경 이미지 (grayscale ↔ color)
 *   1: CTAOverlay     — 반투명 어두운 레이어 (가독성)
 *   2: CTAContent     — 제목, 부제목, CTA 버튼
 *
 * hover 제어:
 *   .ctaSection:hover .backgroundImage { filter: grayscale(0%) }
 */
function CTASection({ onActorSignup, onProducerSignup }) {
  return (
    <section className={styles.ctaSection}>
      <CTABackground
        src={CTA_DATA.background.src}
        alt={CTA_DATA.background.alt}
      />
      <CTAOverlay />
      <CTAContent
        title={CTA_DATA.title}
        subtitle={CTA_DATA.subtitle}
        buttons={CTA_DATA.buttons}
        onActorClick={onActorSignup}
        onProducerClick={onProducerSignup}
      />
    </section>
  );
}

export default CTASection;
